const projectInfo = [
    {
        id: 1,
        img: 'https://i.ibb.co/7rS07zg/Screenshot-2021-05-01-133006.jpg',
        name: 'GOGO Travel',
        description: 'A Single page web app where client can book their events and checkout their information. Admin can add a new Events and can admin another people',
        github:'https://github.com/zamanrabeen671/GOGO-Travel-client',
        liveSite: 'https://gogo-travels.web.app/',
        tools: ['React.js', 'Node.js', 'Express.js', 'MongoDB', 'Firebase', 'Bootstrap', 'Stripe.js'],
    },
    {
        id: 2,
        img: 'https://i.ibb.co/4sF2R5Y/Screenshot-2021-05-01-133123.jpg',
        name: 'Smart Shopping',
        description: 'A Single page web app where client can buy their product and checkout information. Admin can add a new Product',
        github:'https://github.com/zamanrabeen671/smart-shopping-client',
        liveSite: 'https://smart-shopping-671.firebaseapp.com/',
        tools: ['React.js', 'Node.js', 'Express.js', 'MongoDB', 'Firebase', 'Bootstrap'],
    },
    {
        id: 3,
        img: 'https://i.ibb.co/2kJJkyD/Screenshot-2021-05-01-133218.jpg',
        name: 'Take A Trip',
        description: 'A Ride Sharing Web App Where passenger can take a trip. Show Dynamic routing by using Google Map',
        github:'https://github.com/zamanrabeen671/Take-A-Trip',
        liveSite: 'https://take-a-trip-671.web.app/',
        tools: ['React.js',  'React Router', 'Firebase', 'Bootstrap', 'Google Map'],
    },
    {
        id: 4,
        img: 'https://i.ibb.co/Cm0vD3x/Screenshot-2021-05-02-005416.jpg',
        name: 'League of Legend',
        description: 'A Single English Premier league Web App. Where you see 15 Legendary club information like their Establishing Stadium Club Players etc',
        github:'https://github.com/zamanrabeen671/League-of-Legend',
        liveSite: 'https://league-of-legends-671.netlify.app/',
        tools: ['React.js', 'React Router', 'Bootstrap', 'Netlify','REST API'],
    },
    {
        id: 5,
        img: 'https://i.ibb.co/2ts9xj4/Screenshot-2021-05-02-005850.jpg',
        name: 'Hungry Monster',
        description: 'An Online Food Restora App where your a search a meal and select your favorite food. We serve best fresh food',
        github:'https://github.com/zamanrabeen671/Hungry-Monster',
        liveSite: 'https://zamanrabeen671.github.io/Hungry-Monster/',
        tools: ['JavaScript', 'MealDB API', 'HTML', 'CSS', 'Bootstrap'],
    },
    {
        id: 6,
        img: 'https://i.ibb.co/4FhbkvZ/Screenshot-2021-05-02-010137.jpg',
        name: 'Penguin Fashion',
        description: 'An E-commerce Shopping Site where customer can see many product for his fashion life. we provide best qualified product',
        github:'https://github.com/zamanrabeen671/responsive-website',
        liveSite: 'https://zamanrabeen671.github.io/responsive-website/',
        tools: ['HTML','CSS','Bootstrap'],
    },
]
export default projectInfo;